const gql = require("graphql-tag");

const ACTIVE_USER = gql`
  query {
    activeUser {
      id
      username
      name
      surname
      isActive
    }
  }
`;

export const userQueries = {
  ACTIVE_USER,
};
